(function() {
  var STORAGE_KEY = 'shenanigans_recent_product_handles';
  var currentHandle = document.body.getAttribute('data-current-product-handle');

  function readHandles() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      return [];
    }
  }

  function saveCurrentProduct() {
    if (!currentHandle) return;
    var handles = readHandles().filter(function(handle) {
      return handle !== currentHandle;
    });
    handles.unshift(currentHandle);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, 12)));
    } catch (error) {}
  }

  function loadRecommendationSections() {
    var loaders = document.querySelectorAll('[data-recommendations-url]');
    Array.prototype.forEach.call(loaders, function(loader) {
      fetch(loader.getAttribute('data-recommendations-url'))
        .then(function(response) {
          if (!response.ok) throw new Error('Recommendation request failed');
          return response.text();
        })
        .then(function(text) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = text;
          var content = wrapper.querySelector('[data-recommendations-content]');
          if (content) loader.replaceWith(content);
        })
        .catch(function() {});
    });
  }

  function loadBestSellerSections() {
    var loaders = document.querySelectorAll('[data-bestsellers-url]');
    Array.prototype.forEach.call(loaders, function(loader) {
      fetch(loader.getAttribute('data-bestsellers-url'))
        .then(function(response) {
          if (!response.ok) throw new Error('Best-seller request failed');
          return response.text();
        })
        .then(function(text) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = text;
          var content = wrapper.querySelector('[data-bestsellers-content]');
          if (content) loader.replaceWith(content);
        })
        .catch(function() {});
    });
  }

  function money(cents) {
    var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function productCard(product) {
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var item = document.createElement('li');
    item.className = 'grid__item small--one-half medium-up--one-quarter';
    item.innerHTML = '<div class="grid-view-item product-card">' +
      '<a class="grid-view-item__link" href="' + product.url + '">' +
      (image ? '<img class="replacement-recommendations__image" src="' + image + '" alt="">' : '') +
      '<span class="h4 grid-view-item__title product-card__title">' + product.title + '</span>' +
      '<span class="price-item price-item--regular">' + money(product.price) + '</span>' +
      '</a></div>';
    return item;
  }

  function loadPersonalizedProducts() {
    var section = document.querySelector('[data-personalized-recommendations]');
    if (!section) return;

    var handles = readHandles().filter(function(handle) {
      return handle !== currentHandle;
    }).slice(0, 8);
    // Keep the full fallback grid until there is enough browsing history to
    // make this section genuinely useful (instead of collapsing to one item).
    if (handles.length < 4) return;

    Promise.all(handles.map(function(handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function(response) {
          if (!response.ok) throw new Error('Product not found');
          return response.json();
        })
        .catch(function() { return null; });
    })).then(function(products) {
      products = products.filter(function(product) {
        return product && product.available;
      });
      if (products.length < 4) return;

      var list = section.querySelector('[data-personalized-products]');
      var fallback = section.querySelector('[data-personalized-fallback]');
      products.forEach(function(product) {
        list.appendChild(productCard(product));
      });
      list.hidden = false;
      fallback.hidden = true;
    });
  }

  saveCurrentProduct();
  loadRecommendationSections();
  loadBestSellerSections();
  loadPersonalizedProducts();
})();
